import { createContext } from 'react'
import { type StoreConfigurationScopedRouteParams } from '../../legacy/common/types'

/**
 * The scope route params (partner_id / warehouse_id / storeConfigId) a native
 * TanStack route exposes. Partial: a given route only carries the scopes it declares.
 */
export type NativeScopeParams = Partial<StoreConfigurationScopedRouteParams>

export interface NativeScopeValue {
  /** True when a real TanStack route — not the legacy `$` catch-all — owns the URL. */
  isNative: boolean
  params: NativeScopeParams
  /**
   * Every param of the matched native branch, scope and page params alike (TanStack merges
   * params down the branch). Read through `useRouteParams`; empty when not native.
   */
  allParams: Readonly<Record<string, string | undefined>>
}

/**
 * Bridges TanStack route params to the eager scope hooks without pulling @tanstack
 * into the boot bundle: this module imports no router. The shell's (lazy-loaded)
 * `NativeScopeProvider` fills it from TanStack; the eager `useScopeParams` reads it.
 *
 * Default is non-native, so flag-off — where no provider mounts — the eager hooks
 * fall through to their RRv5 read.
 */
export const NativeScopeContext = createContext<NativeScopeValue>({
  isNative: false,
  params: {},
  allParams: {},
})
